import client from '@/utils/request';
import { SALES_API_BASE_URL as API_BASE_URL } from './base_url';

export const getResumeConsultGoods = () => {
  return client.get(`${API_BASE_URL}/goods/query/?type=mentor`);
};

export const createPaymentOrder = (goods: string[]) => {
  return client.post(`${API_BASE_URL}/goods/payment_order/`, { goods });
};

export const wechatPay = (orderId: string, code: string) => {
  return client.post(`${API_BASE_URL}/wechatpay/pay/`, {
    order_id: orderId,
    code,
  });
};

export const wechatPayH5 = (orderId: string) => {
  return client.post(`${API_BASE_URL}/wechatpay/pay_h5/`, {
    order_id: orderId,
  });
};

export const getPaymentOrderData = (orderId: string) => {
  return client.get(`${API_BASE_URL}/payment_orders/${orderId}/`);
};
